// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard.inner-wrap {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
}

.dashboard .content-container {
    width: 100%;
    /* max-width: 38.75rem; */
    /* max-width: 100%; */
}

.dashboard .main-title-wrap {
    /*padding-top: .75rem;*/
    border-bottom: .0625rem solid #d1d5d9;
}

.dashboard .main-title-wrap .title {
    display: inline-block;
    position: relative;
    padding: 0 1rem;
    /* font-size: .9rem; */
    font-weight: bold;
    line-height: 2.5rem;
}

.dashboard .main-title-wrap .title:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
}

.dashboard .main-title-wrap .btn-wrap {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding-top: .75rem;
}

.dashboard .main-title-wrap .btn-wrap button {
    width: 2.25rem;
    height: 2.25rem;
}

.dashboard .main-title-wrap .btn-wrap button+button {
    margin-left: .25rem;
}

.dashboard .main-title-wrap .btn-wrap button svg {
    width: auto;
    height: 1.75rem;
    margin: 0 auto;
}

.dashboard .panel {
    margin: .5rem 0;
}

.dashboard .sales .panel {
    display: flex;
    flex-direction: column;
}

.dashboard .sales .panel ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;
    border-radius: 10px;
}

/* .dashboard .sales .panel ul + ul { margin-top:.875rem; } */
.dashboard .sales .panel ul li {
    display: flex;
    flex-direction: row;
    width: 100%;
    /* align-items: center; */
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    padding: .75rem .75rem;
    /* padding: 1rem; */
    /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */
    background: #fff;
}

.dashboard .sales .panel ul li:first-child {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
    border-bottom: .0625rem solid rgba(0, 0, 0, .08);
}

.dashboard .sales .panel ul li:last-child {
    border-bottom-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
}

.dashboard .sales .panel ul li .calc-title {
    display: block;
    position: relative;
    margin-bottom: 0;
    color: #64748b;
}

.dashboard .sales .panel ul li .calc-item {
    text-align: right;
    white-space: nowrap;
}

.dashboard .sales .panel ul li .calc-item money {
    /* font-size: 1.375rem; */
    font-size: 1.1rem;
    font-weight: bold;
}

.dashboard .sales .panel ul li .cancelation {
    color: #d52424;
}

.dashboard .sales .panel .em li:first-child {
    background: linear-gradient(135deg, #434242, #000000);
}

.dashboard .sales .panel .em li:first-child .calc-title {
    color: #fff;
}

.dashboard .sales .panel .em li:first-child .calc-item money {
    color: #fff;
}

.dashboard .sales .panel .em li:first-child .calc-item span {
    color: rgba(255, 255, 255, .75);
}

.dashboard .sales .panel ul li+li {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.dashboard .sales .panel li+li .calc-title {
    margin: 0;
}

.dashboard .sales .panel li+li .calc-item money {
    font-size: 0.95rem;
    font-weight: 500;
}

.dashboard .sales .panel li+li .calc-item span {}

.dashboard .sales .panel li+li~li {
    margin-top: -1rem;
}

.dashboard .sales .panel {
    flex-direction: column;
    gap: 1rem;
    /* align-items: center; */
}

.dashboard .calc-table li {
    position: relative;
    padding: 1rem 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 /4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .calc-table li+li {
    margin-top: .875rem;
}

.dashboard .calc-table li:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .calc-table li .calc-title {
    display: block;
    margin-bottom: .5rem;
    font-size: .8125rem;
    line-height: 2;
}

.dashboard .calc-table li:nth-child(1) .calc-title {
    color: #0d9488;
}

.dashboard .calc-table li:nth-child(2) .calc-title {
    color: #ff9f89;
}

.dashboard .calc-table li:nth-child(3) .calc-title {
    color: #064e3b;
}

.dashboard .calc-table li:nth-child(4) .calc-title {
    color: #0e9488;
}

.dashboard .calc-table li .calc-item {
    display: inline-block;
    font-size: 1.375rem;
    font-weight: bold;
}

.dashboard .calc-table li .calc-cnt {
    display: inline-block;
    margin-left: .25rem;
    font-size: .8125rem;
    font-weight: 500;
    color: #919599;
}

.dashboard .calc-table li progress {
    display: block;
    width: 100%;
    height: .3125rem;
    margin: .75rem 0 .5rem;
    border-radius: .3125rem;
    overflow: hidden;
}

.dashboard .dailyStatsChart,
.dashboard .monthlyStatsChart {
    height: 16rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    padding: 1rem 1rem;
}

.dashboard .dailyStatsChart canvas,
.dashboard .monthlyStatsChart canvas {
    width: 100% !important;
    height: 100% !important;
}

.dashboard .branchList {
    margin: 1.5rem 0;
}

.dashboard .branchList>div+div {
    margin-top: .875rem;
}

.dashboard .branchList .box {
    position: relative;
    min-height: 4.5rem;
    margin: 0;
    padding: 1rem 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .branchList .box:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .branchList .box>div:nth-child(1) {
    margin-left: 0;
    padding-right: .75rem;
}

.dashboard .branchList .box>div:nth-child(2) {
    flex-shrink: 0;
    padding: .3125rem .625rem;
    font-size: .8125rem;
}

.dashboard .branchList .box>div span {
    flex-shrink: 0;
    display: inline-block;
    position: relative;
    top: -.25rem;
    left: 0;
    width: 2.25rem;
    height: 2.25rem;
    margin-right: .625rem;
    border-radius: 50%;
    border-width: .25rem;
    border-style: solid;
    line-height: 1.8125rem;
    text-align: center;
    color: #fff;
}

.dashboard .branchList .box>div span:after {
    content: "";
    display: block;
    position: absolute;
    top: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 1.125rem;
    border-width: .375rem .625rem;
    border-style: solid;
    border-color: #fc402d #fc402d transparent #fc402d;
    z-index: -1;
    pointer-events: none;
}

.dashboard .branchList .box>div:nth-child(1) div {
    display: flex;
    align-items: center;
    font-size: .875rem;
    font-weight: bold;
}

/* medal index color */
.dashboard .branchList>div:nth-child(1) .box>div:nth-child(1) span {
    border-color: #fadd40;
    box-shadow: inset 0 0 0 #b67d05, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #f9ad0e 50%, #e89f06 50%);
    text-shadow: 0 0 .25rem #9d6c04;
}

.dashboard .branchList>div:nth-child(2) .box>div:nth-child(1) span {
    border-color: #edeff1;
    box-shadow: inset 0 0 0 #a7b2b8, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #d1d7da 50%, #c3cbcf 50%);
    text-shadow: 0 0 .25rem #98a6ad;
}

.dashboard .branchList>div:nth-child(3) .box>div:nth-child(1) span {
    border-color: #f7bb23;
    box-shadow: inset 0 0 0 #955405, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #df7e08 50%, #c67007 50%);
    text-shadow: 0 0 .25rem #7d4604;
}

.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span {
    top: 0;
    box-shadow: none;
    border-color: #e0e1f3;
    background: linear-gradient(to bottom right, #c3c7d3 50%, #b3b6bd 50%);
    text-shadow: 0 0 .25rem #858ea1;
}

.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span:after {
    display: none;
}

.dashboard .notice-wrap>div {
    position: relative;
    min-height: 9.25rem;
    padding: 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .notice-wrap>div:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .notice-wrap>div+div {
    margin-top: .875rem;
}

.dashboard .notice-wrap .text-base {
    margin-bottom: .5rem;
    font-size: .9375rem;
    font-weight: bold;
}

.dashboard .notice-wrap .text-slate-400 {
    /*position: absolute;*/
    /*left: 1.25rem;*/
    /*bottom: 1.25rem;*/
    float: right;
    line-height: 1.4;
}

.dashboard .notice-wrap .text-slate-500 {
    margin: 0;
}

.dashboard .notice-wrap .text-slate-500+div,
.dashboard .notice-wrap .text-slate-500+div button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
}

.agent_panel {
    display: block;
}

.agent_panel-1 {
    width: 100%;
}

.agent_panel-2 {
    width: 100%;
    flex-direction: row !important;
}

.intro-padding {
    padding: 1rem 1rem 0.5rem;
    margin-top: 0.5rem;
}








@media(min-width:1280px) {
    .dashboard .sales {}

    .dashboard .sales .content-wrap {
        flex-direction: column;
    }

    .dashboard .sales .content-item {
        width: auto !important;
    }

    .dashboard .sales .content-item+.content-item {
        margin-top: 1rem;
        /* margin-top: 1.375rem; */
    }

    .dashboard .sales .panel {
        height: auto !important;
        min-height: auto !important;
        column-gap: 1rem;
    }

    .dashboard .sales .panel ul {}

    .dashboard .sales .panel ul+ul {}

    .dashboard .sales .panel ul li {
        /* padding: 1.25rem 1.5rem; */
        padding: 1rem 1rem;
    }

    .dashboard .sales .panel ul li:first-child {}

    .dashboard .sales .panel ul li:last-child {}

    .dashboard .sales .panel ul li .calc-title {
        font-size: 1rem;
    }

    .dashboard .sales .panel ul li .calc-item {}

    .dashboard .sales .panel ul li .calc-item money {
        font-size: 1rem;
        /* font-size: 1.3rem; */
    }

    .dashboard .sales .panel ul li .cancelation {}

    .dashboard .sales .panel .em li:first-child {}

    .dashboard .sales .panel .em li:first-child .calc-title {}

    .dashboard .sales .panel .em li:first-child .calc-item money {}

    .dashboard .sales .panel .em li:first-child .calc-item span {}

    .dashboard .sales .panel ul li+li {}

    .dashboard .sales .panel li+li .calc-title {
        font-size: .8rem;
        /* font-size: .875rem; */
    }

    .dashboard .sales .panel li+li .calc-item money {
        font-size: .95rem;
        /* font-size: 1rem; */
        /* font-size: 1.25rem; */
    }

    .dashboard .sales .panel li+li .calc-item span {}

    .dashboard .sales .panel li+li~li {}

    .dashboard .sales .content-item {
        width: auto !important;
    }

    .dashboard .sales .content-item+.content-item {
        margin-top: 1rem;
        /* margin-top: 1.375rem; */
    }

    .calendar .content-wrap .content-item {
        margin: 0;
    }

    .dashboard .content-wrap .content-item {
        width: 100%;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {
        width: 50%;
        /* margin-right: 2rem; */
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {
        width: 60%;
        margin-right: 2rem;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {
        width: 40%;
        margin-right: 2rem;
    }

    .dashboard.inner-wrap {
        flex-direction: row;
        align-items: flex-start;
        /* padding-top: .5rem; */
    }

    .dashboard .content-container {
        max-width: none;
        height: calc(100dvh - 9rem);
        /* padding: .5rem 0 0; */
    }

    .dashboard .content-container.c-left {
        width: 100%;
        max-width: 1400px;
        /* padding-right: 2rem; */
    }

    .dashboard .content-wrap {
        display: flex;
    }

    .dashboard .content-wrap .content-item {
        width: 100%;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) {
        margin-bottom: 1rem;
    }

    .dashboard .content-container.c-left+.content-container {
        width: 30%;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {
        width: 50%;
        /* margin-right: 2rem; */
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {
        width: 60%;
        margin-right: 2rem;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {
        width: 40%;
        margin-right: 2rem;
    }

    .dashboard .main-title-wrap {
        border: none;
    }

    .dashboard .main-title-wrap .title {
        padding: 0;
        font-size: 1.0625rem;
    }

    .dashboard .main-title-wrap .title:before {
        opacity: 0;
    }

    .dashboard .panel {
        margin: .25rem 0 0;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) .panel {
        height: calc(50vh - 13rem);
        min-height: 12rem;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .panel {
        height: calc(50vh - 6rem);
        min-height: 19rem;
    }

    .dashboard .calc-table {
        height: 100%;
    }

    .dashboard .calc-table li {
        /*height: calc(50% - .5rem);*/
        margin: 0 .5rem;
        padding: 1rem 1.25rem;
    }

    .dashboard .calc-table li:nth-child(n + 3) {
        margin-top: 1rem;
    }

    .dashboard .calc-table li .calc-title {
        font-size: .8125rem;
    }

    .dashboard .dailyStatsChart {
        /*height: 100%*/
    }

    .dashboard .monthlyStatsChart {
        height: 100%;
        padding: 2rem 2rem 1.5rem 1.5rem;
    }

    .dashboard .branchList {
        height: calc(50vh - 6rem);
        min-height: 19rem;
        margin: .25rem 0 0;
    }

    .dashboard .branchList>div {
        height: 20%;
    }

    .dashboard .branchList>div+div {
        margin-top: .125rem;
    }

    .dashboard .branchList .box {
        height: calc(100% - .5rem);
        min-height: auto;
        padding: 0 1.375rem;
    }

    .dashboard .branchList .box>div span {
        top: -.1875rem;
        width: 2rem;
        height: 2rem;
        margin-right: .75rem;
        line-height: 1.5625rem;
    }

    .dashboard .branchList .box>div span:after {
        top: 1.25rem;
    }

    .dashboard .content-container.c-left+.content-container .content-wrap .panel {
        height: calc(100dvh - 13.75rem);
        min-height: 36.25rem;
    }

    .dashboard .notice-wrap {
        height: 100%;
    }

    .dashboard .notice-wrap>div {
        height: 62.5rem;
        /* height: calc(50% - .75rem); */
        min-height: auto;
        padding: 1.25rem;
    }

    .dashboard .notice-wrap .text-slate-500 {
        line-height: 1.4;
    }
}

@media(min-width:768px) {
    .dashboard.inner-wrap {
        /* padding-top: 1rem; */
    }

    .dashboard .main-title-wrap .title,
    .dashboard .branchList .box>div:nth-child(1) div {
        /* font-size: .9375rem; */
    }

    .dashboard .panel {
        /* margin: 1rem 0; */
        flex-direction: row !important;
    }

    .dashboard .calc-table {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% + 1rem);
        margin-left: -.5rem;
    }

    .dashboard .calc-table li {
        width: calc(50% - 1rem);
        margin: 0 .5rem 1rem;
        padding: 1.25rem 1.5rem;
    }

    .dashboard .calc-table li+li {
        margin-top: 0;
    }

    .dashboard .calc-table li .calc-title,
    .dashboard .calc-table li .calc-cnt {
        font-size: .875rem;
    }

    .dashboard .calc-table li progress {
        margin-bottom: 0;
    }

    .dashboard .dailyStatsChart,
    .dashboard .monthlyStatsChart {
        position: relative;
        height: 22rem;
        padding: 1rem 1rem;
        border-radius: .5rem;
        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
        background: #fff;
        overflow: hidden;
    }

    .dashboard .dailyStatsChart:before,
    .dashboard .monthlyStatsChart:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: inherit;
        border: .0625rem solid rgb(0 0 0 / 8%);
        pointer-events: none;
    }

    .dashboard .branchList>div+div,
    .dashboard .notice-wrap>div+div {
        margin-top: 1rem;
    }

    .dashboard .branchList .box {
        min-height: 5rem;
        padding: 1.25rem 1.5rem;
    }

    .dashboard .branchList .box>div:nth-child(2) {
        padding: .5rem 1rem;
        font-size: .875rem;
    }

    .dashboard .branchList .box>div span {
        margin-right: .875rem;
    }

    .dashboard .notice-wrap>div {
        padding: 1.5rem;
    }

    .dashboard .notice-wrap .text-base {
        margin-bottom: .75rem;
    }

    .dashboard .notice-wrap .text-slate-500 {
        line-height: 1.6;
    }

    .dashboard .sales .panel ul li {
        display: flex;
        /* flex-direction: column; */
        position: relative;
        padding: 1rem .75rem;
        /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */
        background: #fff;
        align-items: stretch;
        justify-content: space-between;
    }

    .dashboard .sales .panel ul li .calc-title {
        display: block;
        position: relative;
        /* margin-bottom: .375rem; */
        color: #64748b;
        /* width: 100%; */
    }

    .agent_panel {
        display: flex;
        gap: 1rem;
    }

    .agent_panel-1 {
        width: 50%;
    }

    .agent_panel-2 {
        width: 50%;
    }
}

@media(min-width:640px) {
    .dashboard .sales .panel ul {
        flex-grow: 1;
        flex-basis: 50%;
    }

    .dashboard .sales .panel ul+ul {
        margin: 0;
    }

    .dashboard .sales .panel li+li .calc-title {
        /* padding-left: .5rem; */
    }

    .dashboard .sales .panel li+li .calc-title::before {
        /* content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: .1875rem;
        height: .1875rem;
        border-radius: 50%;
        background: #64748b; */
    }

    .dashboard .sales .panel ul {
        width: 100%;
        /* width: calc((100% - 1rem) / 2); */
    }

    .dashboard .sales .panel ul li+li {
        /* flex-direction: column; */
        align-items: unset;
    }
}

@media (max-width: 640px) {
    .dashboard .sales .panel {
        gap: 0.5rem;
    }
}

@media (max-width: 450px) {
    .dashboard .sales .panel ul li .calc-item money {
        font-size: 1rem;
    }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/css/dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,gDAAgD;;AAEhD;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,iDAAiD;IACjD,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,qBAAqB;IACrB,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;;;;;;;;AASA;IACI,mBAAmB;;IAEnB;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA,6BAA6B;;IAE7B,gCAAgC;;IAEhC;QACI,6BAA6B;QAC7B,kBAAkB;IACtB;;IAEA,4CAA4C;;IAE5C,2CAA2C;;IAE3C;QACI,eAAe;IACnB;;IAEA,2CAA2C;;IAE3C;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA,6CAA6C;;IAE7C,6CAA6C;;IAE7C,yDAAyD;;IAEzD,8DAA8D;;IAE9D,6DAA6D;;IAE7D,mCAAmC;;IAEnC;QACI,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA,gDAAgD;;IAEhD,mCAAmC;;IAEnC;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,2BAA2B;QAC3B,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,+BAA+B;QAC/B,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gCAAgC;QAChC,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;QACpB,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,eAAe;QACf,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,oBAAoB;QACpB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,0CAA0C;QAC1C,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,sBAAsB;QACtB,sCAAsC;QACtC,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,4BAA4B;QAC5B,kBAAkB;QAClB,oBAAoB;QACpB,mDAAmD;QACnD,gBAAgB;QAChB,oBAAoB;QACpB,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,4BAA4B;QAC5B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI;;;;;;;;8BAQsB;IAC1B;;IAEA;QACI,WAAW;QACX,oCAAoC;IACxC;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".dashboard.inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* justify-content: center; */\r\n    align-items: center;\r\n}\r\n\r\n.dashboard .content-container {\r\n    width: 100%;\r\n    /* max-width: 38.75rem; */\r\n    /* max-width: 100%; */\r\n}\r\n\r\n.dashboard .main-title-wrap {\r\n    /*padding-top: .75rem;*/\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.dashboard .main-title-wrap .title {\r\n    display: inline-block;\r\n    position: relative;\r\n    padding: 0 1rem;\r\n    /* font-size: .9rem; */\r\n    font-weight: bold;\r\n    line-height: 2.5rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .title:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    padding-top: .75rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button {\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button+button {\r\n    margin-left: .25rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button svg {\r\n    width: auto;\r\n    height: 1.75rem;\r\n    margin: 0 auto;\r\n}\r\n\r\n.dashboard .panel {\r\n    margin: .5rem 0;\r\n}\r\n\r\n.dashboard .sales .panel {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.dashboard .sales .panel ul {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    background: rgb(255, 255, 255);\r\n    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;\r\n    border-radius: 10px;\r\n}\r\n\r\n/* .dashboard .sales .panel ul + ul { margin-top:.875rem; } */\r\n.dashboard .sales .panel ul li {\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 100%;\r\n    /* align-items: center; */\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    position: relative;\r\n    padding: .75rem .75rem;\r\n    /* padding: 1rem; */\r\n    /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */\r\n    background: #fff;\r\n}\r\n\r\n.dashboard .sales .panel ul li:first-child {\r\n    border-top-left-radius: .5rem;\r\n    border-top-right-radius: .5rem;\r\n    border-bottom: .0625rem solid rgba(0, 0, 0, .08);\r\n}\r\n\r\n.dashboard .sales .panel ul li:last-child {\r\n    border-bottom-left-radius: .5rem;\r\n    border-bottom-right-radius: .5rem;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-title {\r\n    display: block;\r\n    position: relative;\r\n    margin-bottom: 0;\r\n    color: #64748b;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-item {\r\n    text-align: right;\r\n    white-space: nowrap;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-item money {\r\n    /* font-size: 1.375rem; */\r\n    font-size: 1.1rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .sales .panel ul li .cancelation {\r\n    color: #d52424;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child {\r\n    background: linear-gradient(135deg, #434242, #000000);\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-title {\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-item money {\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-item span {\r\n    color: rgba(255, 255, 255, .75);\r\n}\r\n\r\n.dashboard .sales .panel ul li+li {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-title {\r\n    margin: 0;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-item money {\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-item span {}\r\n\r\n.dashboard .sales .panel li+li~li {\r\n    margin-top: -1rem;\r\n}\r\n\r\n.dashboard .sales .panel {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    /* align-items: center; */\r\n}\r\n\r\n.dashboard .calc-table li {\r\n    position: relative;\r\n    padding: 1rem 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 /4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .calc-table li+li {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .calc-table li:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .calc-table li .calc-title {\r\n    display: block;\r\n    margin-bottom: .5rem;\r\n    font-size: .8125rem;\r\n    line-height: 2;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(1) .calc-title {\r\n    color: #0d9488;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(2) .calc-title {\r\n    color: #ff9f89;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(3) .calc-title {\r\n    color: #064e3b;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(4) .calc-title {\r\n    color: #0e9488;\r\n}\r\n\r\n.dashboard .calc-table li .calc-item {\r\n    display: inline-block;\r\n    font-size: 1.375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .calc-table li .calc-cnt {\r\n    display: inline-block;\r\n    margin-left: .25rem;\r\n    font-size: .8125rem;\r\n    font-weight: 500;\r\n    color: #919599;\r\n}\r\n\r\n.dashboard .calc-table li progress {\r\n    display: block;\r\n    width: 100%;\r\n    height: .3125rem;\r\n    margin: .75rem 0 .5rem;\r\n    border-radius: .3125rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .dailyStatsChart,\r\n.dashboard .monthlyStatsChart {\r\n    height: 16rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    padding: 1rem 1rem;\r\n}\r\n\r\n.dashboard .dailyStatsChart canvas,\r\n.dashboard .monthlyStatsChart canvas {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.dashboard .branchList {\r\n    margin: 1.5rem 0;\r\n}\r\n\r\n.dashboard .branchList>div+div {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .branchList .box {\r\n    position: relative;\r\n    min-height: 4.5rem;\r\n    margin: 0;\r\n    padding: 1rem 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .branchList .box:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(1) {\r\n    margin-left: 0;\r\n    padding-right: .75rem;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(2) {\r\n    flex-shrink: 0;\r\n    padding: .3125rem .625rem;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.dashboard .branchList .box>div span {\r\n    flex-shrink: 0;\r\n    display: inline-block;\r\n    position: relative;\r\n    top: -.25rem;\r\n    left: 0;\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n    margin-right: .625rem;\r\n    border-radius: 50%;\r\n    border-width: .25rem;\r\n    border-style: solid;\r\n    line-height: 1.8125rem;\r\n    text-align: center;\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .branchList .box>div span:after {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    top: 1.5rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 1.125rem;\r\n    border-width: .375rem .625rem;\r\n    border-style: solid;\r\n    border-color: #fc402d #fc402d transparent #fc402d;\r\n    z-index: -1;\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(1) div {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n}\r\n\r\n/* medal index color */\r\n.dashboard .branchList>div:nth-child(1) .box>div:nth-child(1) span {\r\n    border-color: #fadd40;\r\n    box-shadow: inset 0 0 0 #b67d05, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #f9ad0e 50%, #e89f06 50%);\r\n    text-shadow: 0 0 .25rem #9d6c04;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(2) .box>div:nth-child(1) span {\r\n    border-color: #edeff1;\r\n    box-shadow: inset 0 0 0 #a7b2b8, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #d1d7da 50%, #c3cbcf 50%);\r\n    text-shadow: 0 0 .25rem #98a6ad;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(3) .box>div:nth-child(1) span {\r\n    border-color: #f7bb23;\r\n    box-shadow: inset 0 0 0 #955405, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #df7e08 50%, #c67007 50%);\r\n    text-shadow: 0 0 .25rem #7d4604;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span {\r\n    top: 0;\r\n    box-shadow: none;\r\n    border-color: #e0e1f3;\r\n    background: linear-gradient(to bottom right, #c3c7d3 50%, #b3b6bd 50%);\r\n    text-shadow: 0 0 .25rem #858ea1;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span:after {\r\n    display: none;\r\n}\r\n\r\n.dashboard .notice-wrap>div {\r\n    position: relative;\r\n    min-height: 9.25rem;\r\n    padding: 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .notice-wrap>div:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .notice-wrap>div+div {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .notice-wrap .text-base {\r\n    margin-bottom: .5rem;\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-400 {\r\n    /*position: absolute;*/\r\n    /*left: 1.25rem;*/\r\n    /*bottom: 1.25rem;*/\r\n    float: right;\r\n    line-height: 1.4;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-500 {\r\n    margin: 0;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-500+div,\r\n.dashboard .notice-wrap .text-slate-500+div button {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    opacity: 0;\r\n}\r\n\r\n.agent_panel {\r\n    display: block;\r\n}\r\n\r\n.agent_panel-1 {\r\n    width: 100%;\r\n}\r\n\r\n.agent_panel-2 {\r\n    width: 100%;\r\n    flex-direction: row !important;\r\n}\r\n\r\n.intro-padding {\r\n    padding: 1rem 1rem 0.5rem;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n@media(min-width:1280px) {\r\n    .dashboard .sales {}\r\n\r\n    .dashboard .sales .content-wrap {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .dashboard .sales .content-item {\r\n        width: auto !important;\r\n    }\r\n\r\n    .dashboard .sales .content-item+.content-item {\r\n        margin-top: 1rem;\r\n        /* margin-top: 1.375rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel {\r\n        height: auto !important;\r\n        min-height: auto !important;\r\n        column-gap: 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul {}\r\n\r\n    .dashboard .sales .panel ul+ul {}\r\n\r\n    .dashboard .sales .panel ul li {\r\n        /* padding: 1.25rem 1.5rem; */\r\n        padding: 1rem 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li:first-child {}\r\n\r\n    .dashboard .sales .panel ul li:last-child {}\r\n\r\n    .dashboard .sales .panel ul li .calc-title {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .calc-item {}\r\n\r\n    .dashboard .sales .panel ul li .calc-item money {\r\n        font-size: 1rem;\r\n        /* font-size: 1.3rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .cancelation {}\r\n\r\n    .dashboard .sales .panel .em li:first-child {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-title {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-item money {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-item span {}\r\n\r\n    .dashboard .sales .panel ul li+li {}\r\n\r\n    .dashboard .sales .panel li+li .calc-title {\r\n        font-size: .8rem;\r\n        /* font-size: .875rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-item money {\r\n        font-size: .95rem;\r\n        /* font-size: 1rem; */\r\n        /* font-size: 1.25rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-item span {}\r\n\r\n    .dashboard .sales .panel li+li~li {}\r\n\r\n    .dashboard .sales .content-item {\r\n        width: auto !important;\r\n    }\r\n\r\n    .dashboard .sales .content-item+.content-item {\r\n        margin-top: 1rem;\r\n        /* margin-top: 1.375rem; */\r\n    }\r\n\r\n    .calendar .content-wrap .content-item {\r\n        margin: 0;\r\n    }\r\n\r\n    .dashboard .content-wrap .content-item {\r\n        width: 100%;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {\r\n        width: 50%;\r\n        /* margin-right: 2rem; */\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {\r\n        width: 60%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {\r\n        width: 40%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard.inner-wrap {\r\n        flex-direction: row;\r\n        align-items: flex-start;\r\n        /* padding-top: .5rem; */\r\n    }\r\n\r\n    .dashboard .content-container {\r\n        max-width: none;\r\n        height: calc(100dvh - 9rem);\r\n        /* padding: .5rem 0 0; */\r\n    }\r\n\r\n    .dashboard .content-container.c-left {\r\n        width: 100%;\r\n        max-width: 1400px;\r\n        /* padding-right: 2rem; */\r\n    }\r\n\r\n    .dashboard .content-wrap {\r\n        display: flex;\r\n    }\r\n\r\n    .dashboard .content-wrap .content-item {\r\n        width: 100%;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) {\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left+.content-container {\r\n        width: 30%;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {\r\n        width: 50%;\r\n        /* margin-right: 2rem; */\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {\r\n        width: 60%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {\r\n        width: 40%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard .main-title-wrap {\r\n        border: none;\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .dashboard .panel {\r\n        margin: .25rem 0 0;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) .panel {\r\n        height: calc(50vh - 13rem);\r\n        min-height: 12rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .panel {\r\n        height: calc(50vh - 6rem);\r\n        min-height: 19rem;\r\n    }\r\n\r\n    .dashboard .calc-table {\r\n        height: 100%;\r\n    }\r\n\r\n    .dashboard .calc-table li {\r\n        /*height: calc(50% - .5rem);*/\r\n        margin: 0 .5rem;\r\n        padding: 1rem 1.25rem;\r\n    }\r\n\r\n    .dashboard .calc-table li:nth-child(n + 3) {\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .dashboard .calc-table li .calc-title {\r\n        font-size: .8125rem;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart {\r\n        /*height: 100%*/\r\n    }\r\n\r\n    .dashboard .monthlyStatsChart {\r\n        height: 100%;\r\n        padding: 2rem 2rem 1.5rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .branchList {\r\n        height: calc(50vh - 6rem);\r\n        min-height: 19rem;\r\n        margin: .25rem 0 0;\r\n    }\r\n\r\n    .dashboard .branchList>div {\r\n        height: 20%;\r\n    }\r\n\r\n    .dashboard .branchList>div+div {\r\n        margin-top: .125rem;\r\n    }\r\n\r\n    .dashboard .branchList .box {\r\n        height: calc(100% - .5rem);\r\n        min-height: auto;\r\n        padding: 0 1.375rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span {\r\n        top: -.1875rem;\r\n        width: 2rem;\r\n        height: 2rem;\r\n        margin-right: .75rem;\r\n        line-height: 1.5625rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span:after {\r\n        top: 1.25rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left+.content-container .content-wrap .panel {\r\n        height: calc(100dvh - 13.75rem);\r\n        min-height: 36.25rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap {\r\n        height: 100%;\r\n    }\r\n\r\n    .dashboard .notice-wrap>div {\r\n        height: 62.5rem;\r\n        /* height: calc(50% - .75rem); */\r\n        min-height: auto;\r\n        padding: 1.25rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-slate-500 {\r\n        line-height: 1.4;\r\n    }\r\n}\r\n\r\n@media(min-width:768px) {\r\n    .dashboard.inner-wrap {\r\n        /* padding-top: 1rem; */\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title,\r\n    .dashboard .branchList .box>div:nth-child(1) div {\r\n        /* font-size: .9375rem; */\r\n    }\r\n\r\n    .dashboard .panel {\r\n        /* margin: 1rem 0; */\r\n        flex-direction: row !important;\r\n    }\r\n\r\n    .dashboard .calc-table {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        width: calc(100% + 1rem);\r\n        margin-left: -.5rem;\r\n    }\r\n\r\n    .dashboard .calc-table li {\r\n        width: calc(50% - 1rem);\r\n        margin: 0 .5rem 1rem;\r\n        padding: 1.25rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .calc-table li+li {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .dashboard .calc-table li .calc-title,\r\n    .dashboard .calc-table li .calc-cnt {\r\n        font-size: .875rem;\r\n    }\r\n\r\n    .dashboard .calc-table li progress {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart,\r\n    .dashboard .monthlyStatsChart {\r\n        position: relative;\r\n        height: 22rem;\r\n        padding: 1rem 1rem;\r\n        border-radius: .5rem;\r\n        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n        background: #fff;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart:before,\r\n    .dashboard .monthlyStatsChart:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        border-radius: inherit;\r\n        border: .0625rem solid rgb(0 0 0 / 8%);\r\n        pointer-events: none;\r\n    }\r\n\r\n    .dashboard .branchList>div+div,\r\n    .dashboard .notice-wrap>div+div {\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .dashboard .branchList .box {\r\n        min-height: 5rem;\r\n        padding: 1.25rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div:nth-child(2) {\r\n        padding: .5rem 1rem;\r\n        font-size: .875rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span {\r\n        margin-right: .875rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap>div {\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-base {\r\n        margin-bottom: .75rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-slate-500 {\r\n        line-height: 1.6;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li {\r\n        display: flex;\r\n        /* flex-direction: column; */\r\n        position: relative;\r\n        padding: 1rem .75rem;\r\n        /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */\r\n        background: #fff;\r\n        align-items: stretch;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .calc-title {\r\n        display: block;\r\n        position: relative;\r\n        /* margin-bottom: .375rem; */\r\n        color: #64748b;\r\n        /* width: 100%; */\r\n    }\r\n\r\n    .agent_panel {\r\n        display: flex;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .agent_panel-1 {\r\n        width: 50%;\r\n    }\r\n\r\n    .agent_panel-2 {\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n@media(min-width:640px) {\r\n    .dashboard .sales .panel ul {\r\n        flex-grow: 1;\r\n        flex-basis: 50%;\r\n    }\r\n\r\n    .dashboard .sales .panel ul+ul {\r\n        margin: 0;\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-title {\r\n        /* padding-left: .5rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-title::before {\r\n        /* content: \"\";\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 0;\r\n        transform: translateY(-50%);\r\n        width: .1875rem;\r\n        height: .1875rem;\r\n        border-radius: 50%;\r\n        background: #64748b; */\r\n    }\r\n\r\n    .dashboard .sales .panel ul {\r\n        width: 100%;\r\n        /* width: calc((100% - 1rem) / 2); */\r\n    }\r\n\r\n    .dashboard .sales .panel ul li+li {\r\n        /* flex-direction: column; */\r\n        align-items: unset;\r\n    }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .dashboard .sales .panel {\r\n        gap: 0.5rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n    .dashboard .sales .panel ul li .calc-item money {\r\n        font-size: 1rem;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
